<template>
  <div :class="['callout', calloutType.style]">
    <template v-if="type === 'newFeature'">
      <div class="callout__image">
        <slot name="image" />
      </div>
      <div class="callout-container">
        <div class="callout-content">
          <span class="callout__new">NEW!</span>
          <div class="callout__title">
            <slot name="title" />
          </div>
          <div class="callout__message">
            <slot name="message" />
          </div>
        </div>
        <div class="callout-actions">
          <slot name="actions" />
        </div>
      </div>
    </template>
    <template v-else>
      <span
        class="callout__icon"
        v-html="calloutType.icon"
      > </span>
      <div class="callout__message">
        <slot name="message" />
      </div>
    </template>
  </div>
</template>

<script>
import feather from 'feather-icons'
const _iconOptions = {
  width: '1.5em',
  height: '1.5em',
}
export default {
  name: 'Callout',
  props: ['type'],
  data() {
    return {
      infoIcon: feather.icons.info.toSvg(_iconOptions),
      warningIcon: feather.icons['alert-circle'].toSvg(_iconOptions),
      dangerIcon: feather.icons['alert-octagon'].toSvg(_iconOptions),
    }
  },
  computed: {
    calloutType() {
      const _types = {
        info: {
          icon: this.infoIcon,
          style: 'callout--info',
        },
        warning: {
          icon: this.warningIcon,
          style: 'callout--warning',
        },
        danger: {
          icon: this.dangerIcon,
          style: 'callout--danger',
        },
        newFeature: {
          style: 'callout--feature',
        },
      }
      return this.type ? _types[this.type] : _types.info
    },
  },
}
</script>

<style lang="scss" scoped>
.callout {
  @include flex-display();
  margin: 1em 0;
  padding: 1em;
  border-radius: 5px;
  font-size: $small-font;
  &--info {
    background: lighten($blue, 32%);
  }
  &--warning {
    background: $off-white;
  }
  &--danger {
    background: lighten($red, 40%);
  }
  &--feature {
    background: $white;
    border: 2px solid $green;
  }
  &-container {
    @include flex-display();
    @include flex-justify-content(space-between);
    @include flex-align-items(center);
    width: 100%;
  }
  &-content {
    @include flex-display();
    flex-direction: column;
  }
  &-actions {
    @include flex-display();
    @include flex-justify-content(space-between);
  }
  &__new {
    color: $green;
    font-weight: 600;
    font-size: $small-font;
  }
  &__icon {
    color: $dark-grey;
    margin-right: 1em;
  }
  &__image {
    min-width: 50px;
    height: auto;
    margin-right: 2em;
  }
  &__title {
    font-size: $large-font;
    font-weight: 600;
  }
}
</style>
